import styled from "styled-components";
import { Checkbox } from "antd";
import { theme } from "../../styles/theme";

export const AntCheckbox = styled(Checkbox)`
  /* Override Ant Styles */
  && {
    &.ant-checkbox-wrapper {
      &:hover {
        & .ant-checkbox {
          &:not(.ant-checkbox-disabled):not(.ant-checkbox-checked) {
            .ant-checkbox-inner {
              border-color: ${theme.colors.red};
              background-color: ${theme.colors.blue500};
            }
          }
        }
      }
      .ant-checkbox:hover .ant-checkbox-inner {
        border-color: ${theme.colors.red};
        background-color: ${theme.colors.red};
      }

      &-disabled {
        .ant-checkbox {
          & + span {
            color: ${theme.colors.gray400};
          }
        }
      }
    }

    .ant-checkbox {
      .ant-checkbox-inner {
        background: transparent;
        border-radius: 4px;
        border-color: ${(props) =>
          props.error ? props.theme.colors.alert.red : props.theme.colors.red};
      }

      &-checked {
        &:after {
          border: 0;
          border-radius: 0;
        }

        .ant-checkbox-inner {
          border-color: ${theme.colors.green};
          background-color: ${theme.colors.red};
        }
      }

      // Label
      & + span {
        color: ${(props) =>
          props.colorLabel ? props.colorLabel : props.theme.colors.gray200};
        font-family: ${theme.fonts.family};
      }
    }
  }
`;
